import { RouteConfig } from 'vue-router'
import Layout from '@/layout/index.vue'
const equipRouter = {
  path: '/adminManage',
  redirect: 'noredirect',
  name: 'adminManage',
  component: Layout,
  meta: {
    title: '课题申报管理',
    icon: 'topicManage'
  },
  children: [
    {
      path: 'expertmanage',
      component: () => import('@/views/topicManage/expertmanage/index.vue'),
      name: 'expertmanage',
      meta: {
        title: '课题申报',
        icon: 'expert',
        requireAuth: true
      }
    },
  ]
}

export default equipRouter
